module.exports = __webpack_public_path__ + "img/rollsroyce_thumbnail.ce01eb59.png";